export enum PaymentsPermissions {
  GET_PAYMENTS = 'payments.getPayments',
  RECORD_PAYMENT = 'payments.recordPayment',
  CONFIRM_PAYMENT = 'payments.confirmPayment',
  TAKE_PAYMENT = 'payments.takePayment',
  BULK_MARK_INVOICES_PAID = 'payments.bulkMarkInvoicesPaid',
}
